//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import productRangeQuery from '~/apollo/queries/product/range'
import productCategoriesQuery from '~/apollo/queries/product/categories'

export default {
  mixins: [seo],
  apollo: {
    productRange: {
      query: productRangeQuery,
      prefetch: true,
      result ({ data }) {
        if (data && data.productRange) {
          this.seoTitle = data.productRange.pageTitle
        }
      },
      error (err) {
        console.log('[productRange query error]', err.message)
      }
    },
    productCategories: {
      query: productCategoriesQuery,
      prefetch: true
    }
  }
}

